import React, { Component } from 'react';
import { Image, Button, Table, Form, FormGroup, ControlLabel, FormControl, HelpBlock, Grid, Col, ButtonToolbar } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { FormModal } from '../../../FormModal';
import { TitleRow } from '../../../../components/TitleRow';
import { HandleDialog } from '../../../HandleDialog';
import { InterfaceAPI } from '../../../../api/files/InterfaceAPI';
import { TableButton } from '../../../TableButton';
import { HandleMessage } from '../../../HandleMessage';
import { strings } from '../strings';
import { PaginationHelper } from '../../../helpers/PaginationHelper';
import { PaginationBuilder } from '../../../PaginationBuilder';
import { SearchBar } from '../../../SearchBar';
import { SearchHelper } from '../../../helpers/SearchHelper';
import { EditionSelector } from '../../../EditionSelector';

export class ProviderInterfaces extends Component {
    static contextTypes = {
        selectedProvider: PropTypes.string
    }

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            pictograms: [],
            showDialog: false,
            showDeleteDialog: false,
            selectedPictogram: undefined,

            showErrorModal: false,
            alertTitle: undefined,
            icon: undefined,
            alertMessage: undefined,
            alertStyle: undefined,

            filter: "",
            currentPage: 1,
            elementsPerPage: 10,
        }
    }

    componentDidMount() {
        // Add as observer
        this.getPictograms();
    }

    // ----------------------

    getPictograms() {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        InterfaceAPI.list(selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loading: false,
                    pictograms: data
                });
            })
            .catch((err) => {
                this.setState({
                    loading: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                })
            });
    }

    openEditDialog(pictogram) {
        this.setState({
            showDialog: true,
            selectedPictogram: Object.assign({}, pictogram)
        });
    }

    closeDialog() {
        this.setState({
            showDialog: false,
            selectedPictogram: undefined
        });
    }

    saveAndCloseDialog() {
        var { selectedPictogram } = this.state;
        var next;

        if (selectedPictogram.id === undefined) {
            next = InterfaceAPI.create(selectedPictogram);
        } else {
            next = InterfaceAPI.update(selectedPictogram.id, selectedPictogram);
        }

        next.then(response => JSON.parse(response))
            .then(data => {
                this.getPictograms();
            })
            .finally(() => {
                this.setState({
                    showDialog: false,
                    selectedPictogram: undefined,
                    alertTitle: "Sucesso",
                    alertMessage: "Interface guardada com sucesso.",
                    alertStyle: 'success',
                    icon: 'ok',
                    showErrorModal: true
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                })
            });
    }

    openCreateDialog() {
        this.setState({
            showDialog: true,
            selectedPictogram: { url: undefined, namePt: undefined, nameEn: undefined }
        })
    }

    uploadImage(image) {
        InterfaceAPI.uploadImage(image)
            .then(response => JSON.parse(response))
            .then(data => {
                let updatedPictogram = this.state.selectedPictogram;
                updatedPictogram.url = data.url;
                this.setState({
                    selectedPictogram: updatedPictogram
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                })
            });
    }

    openDeleteDialog(pictogramToDelete) {
        this.setState({
            showDeleteDialog: true,
            selectedPictogram: pictogramToDelete,
            alertTitle: "Aviso",
            alertMessage: `${strings.deletePictogramConfirmation} "${pictogramToDelete.namePt}"?`,
            icon: 'alert',
            alertStyle: "warning"
        });
    }

    onChangePage = (page) => {
        this.setState({
            currentPage: page
        });
    }

    onChangeElementsPerPage = (elements) => {
        this.setState({
            elementsPerPage: elements
        });
    }

    onSearch(filter) {
        this.setState({
            filter: filter
        });
    }

    clearError = () => {
        this.setState({
            showErrorModal: false,
            alertTitle: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            icon: undefined,
        })
    }

    deletePictogram = (isToExecute) => {
        if (isToExecute) {
            var { selectedPictogram } = this.state;

            InterfaceAPI.delete(selectedPictogram.id)
                .then(response => JSON.parse(response))
                .then(data => {
                    this.getPictograms();
                })
                .finally(() => {
                    this.setState({
                        showDeleteDialog: false,
                        selectedPictogram: undefined,
                        alertTitle: "Sucesso",
                        alertMessage: "Interface removida com sucesso.",
                        alertStyle: 'success',
                        icon: 'ok',
                        showErrorModal: true
                    });
                })
                .catch((err) => {
                    this.setState({
                        alertTitle: "Erro",
                        alertMessage: err.message,
                        alertStyle: 'danger',
                        icon: 'remove',
                        showErrorModal: true
                    })
                })
        }

        this.setState({
            showDeleteDialog: false
        });
    }

    removeImage() {
        let updatedPictogram = this.state.selectedPictogram;
        updatedPictogram.url = undefined;
        this.setState({
            selectedPictogram: updatedPictogram
        });
    }

    setVariableValue(e, variable) {
        let updatedPictogram = this.state.selectedPictogram;
        let updatedValue = e.target.value;
        updatedPictogram[variable] = updatedValue;
        this.setState({
            selectedPictogram: updatedPictogram
        });
    }

    validateNamePt() {
        if (this.state.selectedPictogram.namePt !== undefined && this.state.selectedPictogram.namePt !== "" && this.state.selectedPictogram.namePt.length > 0) {
            return "success";
        } else {
            return "error";
        }
    }

    validateUrl() {
        if (this.state.selectedPictogram.url !== undefined && this.state.selectedPictogram.url !== "" && this.state.selectedPictogram.url.length > 0) {
            return "success";
        } else {
            return "error";
        }

    }

    renderPictogramList() {
        var { pictograms, filter } = this.state;
        const pictogramFilter = SearchHelper.search({
            filter: filter,
            data: pictograms,
            fields: ["namePt", "nameEn"],
        });

        const totalPages = PaginationHelper.getTotalPages(pictogramFilter.length, this.state.elementsPerPage);
        const activePage = totalPages < this.state.currentPage ? totalPages : this.state.currentPage;
        const pictogramsToRender = pictogramFilter.sort((a, b) => a.namePt !== b.namePt ? a.namePt < b.namePt ? -1 : 1 : 0)
            .slice((activePage - 1) * this.state.elementsPerPage, activePage * this.state.elementsPerPage);

        return (
            <Grid fluid className="table-small-screens">
                {pictogramsToRender.length !== 0
                    ?
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th>{strings.namePt}</th>
                                <th>{strings.nameEn}</th>
                                <th>{strings.image}</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                pictogramsToRender.map((pictogram, idx) =>
                                    <tr key={`pictogram-${idx}`}>
                                        <td>{pictogram.namePt}</td>
                                        <td>{pictogram.nameEn}</td>
                                        <td><Image src={pictogram.url} thumbnail style={{ maxWidth: 100, maxHeight: 100 }} /></td>
                                        <td>
                                            {undefined !== this.context.selectedProvider ?
                                                <ButtonToolbar className="pull-right">
                                                    <TableButton disabled marginRight icon="icon-edit" title="Editar" onClick={() => this.openEditDialog(pictogram)} />
                                                    <TableButton disabled icon="icon-trash" title="Eliminar" onClick={() => this.openDeleteDialog(pictogram)} />
                                                </ButtonToolbar>
                                                :
                                                <ButtonToolbar className="pull-right">
                                                    <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.openEditDialog(pictogram)} />
                                                    <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.openDeleteDialog(pictogram)} />
                                                </ButtonToolbar>
                                            }
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>
                    : <p className="empty-set">{strings.noExistingPictograms}</p>
                }
                <PaginationBuilder currentPage={this.state.currentPage} elementsPerPage={this.state.elementsPerPage} dataLength={pictogramFilter.length} onChangePage={this.onChangePage}
                    onChangeElementsPerPage={this.onChangeElementsPerPage} />
            </Grid>
        )
    }

    render() {
        if (this.state.loading) {
            return <LoadingSpinner />
        }

        return (
            <div>
                <EditionSelector />

                <TitleRow title={this.props.title} showSeparator={true}>

                    <Col className="padding-0" xs={2} sm={1} md={4}>
                        <ButtonToolbar className="pull-right title-row-col-btns">
                            <Button disabled={undefined !== this.context.selectedProvider} onClick={() => this.openCreateDialog()} className="pull-right">{strings.newPictogram}</Button>
                        </ButtonToolbar>
                    </Col>
                    <Col className="padding-0" xs={10} sm={11} md={8}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>
                {this.renderPictogramList()}
                <FormModal show={this.state.showDialog} onHide={() => this.closeDialog()} title={strings.newPictogram}
                    onSubmit={() => this.saveAndCloseDialog()} actionTitle={strings.change} cancelTitle={strings.cancel}>
                    {this.state.selectedPictogram !== undefined
                        ? <Form className="form-horizontal">
                            <FormGroup controlId="pictogram-name-pt" validationState={this.validateNamePt()}>
                                <ControlLabel className="col-md-2">{strings.namePtLong}</ControlLabel>
                                <div className="col-md-10">
                                    <FormControl value={undefined !== this.state.selectedPictogram.namePt ? this.state.selectedPictogram.namePt : ''} onChange={(e) => this.setVariableValue(e, "namePt")} />
                                    <FormControl.Feedback />
                                    {this.validateNamePt() !== "success"
                                        ? <HelpBlock>{strings.required}</HelpBlock>
                                        : null}
                                </div>
                            </FormGroup>

                            <FormGroup controlId="pictogram-name-en">
                                <ControlLabel className="col-md-2">{strings.nameEnLong}</ControlLabel>
                                <div className="col-md-10">
                                    <FormControl value={undefined !== this.state.selectedPictogram.nameEn ? this.state.selectedPictogram.nameEn : ''} onChange={(e) => this.setVariableValue(e, "nameEn")} />
                                    <FormControl.Feedback />
                                </div>
                            </FormGroup>

                            <FormGroup controlId="pictogram-image" validationState={this.validateUrl()}>
                                <ControlLabel className="col-md-2">{strings.image}</ControlLabel>
                                <div className="col-md-6">
                                    {this.state.selectedPictogram.url !== undefined ?
                                        <div>
                                            <Image src={this.state.selectedPictogram.url} thumbnail style={{ maxWidth: 100, maxHeight: 100 }} />
                                            <Button style={{ verticalAlign: "bottom", marginLeft: 20 }} onClick={() => this.removeImage()}>{strings.removeImage} </Button>
                                        </div>
                                        :
                                        <FormControl type="file" label={strings.upload} accept=".png,.bmp,.svg,.jpg,.gif" style={{ paddingTop: 7 }} onChange={e => this.uploadImage(e.target.files[0])} />
                                    }
                                    {this.validateUrl() !== "success"
                                        ? <HelpBlock>{strings.required}</HelpBlock>
                                        : null}
                                </div>
                            </FormGroup>
                        </Form>
                        : null}
                </FormModal>

                <HandleDialog
                    show={this.state.showDeleteDialog}
                    title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    icon={this.state.icon}
                    style={this.state.alertStyle}
                    onExit={this.deletePictogram} />

                <HandleMessage
                    title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    icon={this.state.icon}
                    style={this.state.alertStyle}
                    show={this.state.showErrorModal}
                    onHide={this.clearError} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/files/interfaces/providerInterfaces/ProviderInterfaces.js